<template>
  <div>
    <BModal
      :id="id"
      hide-footer
      hide-header
      :centered="true"
      content-class="rounded-md"
      @shown="onShown"
      @hide="onHide"
    >
      <h1 class="text-[#333333] font-semibold text-[18px] text-center mt-1 mb-[1rem]">
        {{ Boolean(item) ? 'Ubah' : 'Tambah' }} Business Manager
      </h1>
      <div class="px-[.75rem] py-[1rem]">
        <ValidationObserver
          ref="addOrEditForm"
          #default="{ invalid }"
        >
          <BForm @submit.prevent="onSubmit">
            <!-- BM Name -->
            <div class="mb-2">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="Nama Business Manager"
                vid="bm_name"
              >
                <label class="text-[#333333] text-[14px] font-medium mb-[8px] block">
                  Nama Business Manager <span class="text-primary">*</span>
                </label>
                <BFormInput
                  v-model="form.bm_name"
                  placeholder="Contoh: Komerce Meta Utama"
                  class="w-full"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  required
                />
                <span
                  v-if="errors.length > 0"
                  class="text-danger text-sm"
                >{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <!-- BM ID -->
            <div class="mb-2">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|numeric"
                name="ID BM"
                vid="bm_id"
              >
                <label class="text-[#333333] text-[14px] font-medium mb-[8px] block">
                  ID BM <span class="text-primary">*</span>
                </label>
                <BFormInput
                  v-model="form.bm_id"
                  placeholder="Masukkan ID BM"
                  class="w-full"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  :disabled="Boolean(item)"
                  required
                />
                <span
                  v-if="errors.length > 0"
                  class="text-danger text-sm"
                >{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <!-- Platform -->
            <div class="mb-2">
              <ValidationProvider
                v-slot="{ errors }"
                name="Platform"
                rules="required"
                vid="platform"
              >
                <div class="mb-[16px] text-left">
                  <label class="text-[#333333] text-[14px] font-medium mb-[8px] block">
                    Platform
                    <span class="text-primary">*</span>
                  </label>
                  <BFormSelect
                    v-model="form.platform"
                    :options="platformOptions"
                    :disabled="Boolean(item)"
                  />
                  <span
                    v-if="errors.length > 0"
                    class="text-danger text-sm"
                  >{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>

            <!-- Limit -->
            <div
              class="mb-2"
            >
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|numeric|min_value:1"
                name="Limit User"
                vid="account_limit"
              >
                <label class="text-[#333333] text-[14px] font-medium mb-[8px] block">
                  Limit User <span class="text-primary">*</span>
                </label>
                <BFormInput
                  v-model="form.account_limit"
                  placeholder="Masukkan Limit"
                  class="w-full"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  required
                />
                <span
                  v-if="errors.length > 0"
                  class="text-danger text-sm"
                >{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <!-- Action Button -->
            <div class="flex flex-row gap-6">
              <BButton
                variant="outline-primary"
                class="rounded grow"
                @click="$emit('close')"
              >
                Batal
              </BButton>
              <BButton
                :variant="!invalid ? 'primary' : 'secondary'"
                class="rounded grow"
                :disabled="invalid"
                type="submit"
              >
                {{ Boolean(item) ? 'Ubah Data' : 'Tambahkan' }}
              </BButton>
            </div>
          </BForm>
        </ValidationObserver>
      </div>
    </BModal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required, numeric } from '@validations'

export default {
  components: { ValidationObserver, ValidationProvider },
  props: {
    id: {
      type: String,
      required: true,
    },
    item: {
      type: Object || null,
      default: null,
    },
  },
  data() {
    return {
      required,
      numeric,
      platformOptions: [
        { value: '', text: 'Pilih Platform Tersedia' },
        { value: 'meta', text: 'Meta' },
      ],
      form: {
        bm_name: '',
        bm_id: '',
        platform: '',
        account_limit: '',
      },
    }
  },
  methods: {
    onShown() {
      if (!this.item) return
      this.form.bm_name = this.item.bm_name
      this.form.bm_id = this.item.bm_id
      this.form.platform = this.item.platform
      this.form.account_limit = this.item.account_limit
    },
    onHide() {
      // remove error mesage
      this.$refs.addOrEditForm.reset()
      // reset form value
      this.resetForm()
    },
    resetForm() {
      this.form.bm_name = ''
      this.form.bm_id = ''
      this.form.platform = ''
      this.form.account_limit = ''
    },
    onSubmit() {
      this.$emit('submit', this.form)
    },
  },
}
</script>
